import styled from "styled-components";

const SelectWrapStyled = styled.div<{ left?: number | undefined }>`
  position: relative;

  & .prefix-icon-wrapper {
    display: flex;
    position: absolute;
    z-index: 1;
    padding: 5px 0 5px 11px;
    width: fit-content;
    height: 100%;
    display: flex;
    align-items: center;
    justify-content: center;
  }

  & .ant-picker.ant-picker-range {
    padding-left: ${({ left }) => (left ? `${left}px` : undefined)};
    padding-right: ${({ left }) => (left ? "25px" : undefined)};
    transition: none;
    & .ant-select-selection-search {
      padding-left: calc(${({ left }) => left || 11}px - 11px);
    }
    &:not(.ant-paicker-focused).has-values {
      // 값있을 때 스타일처리
      border-color: #0d0c0c;
      box-shadow: 0 0 0 2px rgba(0, 0, 0, 0.2);

      & .ant-picker-clear {
        opacity: 1;
      }
    }
    & .ant-picker-active-bar {
      margin-left: ${({ left }) => (left && `${left}px`) || undefined};
    }
  }
`;

export { SelectWrapStyled };
